const actions = {
  hideMessage({ commit }, { message, reportKey }) {
    const view = { reportKey, message: { ...message, isActive: false } }
    commit('view', view)
    return view
  },
  showMessage({ commit }, { message, reportKey }) {
    const view = { reportKey, message: { ...message, isActive: true } }
    commit('view', view)
    return view
  },
  hideErrorMessage({ dispatch }, { error, reportKey }) {
    const type = 'error'
    const { message: text } = error
    const message = { ...error, text, type }

    return dispatch('hideMessage', { message, reportKey })
  },
  showErrorMessage({ dispatch }, { error, reportKey }) {
    const type = 'error'
    const { message: text } = error
    const message = { ...error, text, type }

    return dispatch('showMessage', { message, reportKey })
  },
  hideLoadingMessage({ dispatch }, { reportKey, text }) {
    const type = 'spinner'
    const message = { text, type }

    return dispatch('hideMessage', { message, reportKey })
  },
  showLoadingMessage({ dispatch }, { reportKey, text }) {
    const type = 'spinner'
    const message = { text, type }

    return dispatch('showMessage', { message, reportKey })
  },
  hideStatusMessage({ dispatch, getters }, { reportKey, statusCode }) {
    const { statusCodes } = getters
    const message = statusCodes[statusCode]

    return dispatch('hideMessage', { message, reportKey })
  },
  /**
   * ReportStatus
   * @typedef ReportStatus
   * @property {string} reportKey
   * @property {number} statusCode
   */
  /**
   * VuexContext
   * @typedef VuexContext
   * @property {function} dispatch
   * @property {Object} getters
   */
  /**
   * Updates the StatusMessage rendered to the view.
   * @param {VuexContext} context vuexContext
   * @param {function} context.dispatch vuexDispatch
   * @param {Object} context.getters vuexGetters
   * @param {Object} ReportStatus
   * @param {string} ReportStatus.reportKey
   * @param {number} ReportStatus.statusCode
   * @return {Promise<object>} StatusMessage { reportKey, message }
   */
  showStatusMessage({ dispatch, getters }, { reportKey, statusCode }) {
    const { statusCodes } = getters
    const message = statusCodes.find((status) => status.code === statusCode)

    return dispatch('showMessage', { message, reportKey })
  },

  showSuccessMessage({ dispatch }, { reportKey, text }) {
    const type = 'success'
    const message = { text, type }

    return dispatch('showMessage', { message, reportKey })
  },
  hideSuccessMessage({ dispatch }, { reportKey, text }) {
    const type = 'success'
    const message = { text, type }

    return dispatch('hideMessage', { message, reportKey })
  },
}

export default actions
